import { ROUTES } from '../route/routes';
import { clearLocalHaleSession } from '../theme/brands';
import { removeAll } from '../services/localStorageService';

/**
 * Full-page redirect to login after clearing session storage.
 * Avoids React portal teardown races (MUI Modal/Snackbar) during SPA unmount.
 */
export const redirectToLogin = (): void => {
  clearLocalHaleSession();
  removeAll();
  window.location.assign(ROUTES.LOGIN);
};
